import React from 'react'
//import styled from 'styled-components'

export const Copyright = ({ className, copyright }) => (
	<div className={className}>
		{copyright}
	</div>
)

//export default Copyright